export const ANTHROPIC_MAX_CACHE_CONTROL_BLOCKS = 4; // Anthropic only allows 4 cache control blocks

export const READ_ONLY_FILE_GLOBS = [
  "package.json",
  "pnpm-lock.yaml",
  "package-lock.json",
  "bun.lock",
  "yarn.lock",
  "**/*.lock",
  ".env",
  ".env.*",
  ".git/**",
  "**/.git/**",
  "node_modules/**",
  "**/node_modules/**",
  "dist/**",
  "**/dist/**",
];
